import { Box, BoxProps, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { getCommaFormatedVal, shouldShowTooltip } from '../../util/util'
import { TooltipView } from './TooltipView'

const styles = {
  container: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: 16,
  } as BoxProps,
  subTitleContainer: { flexDirection: 'row', marginTop: 5, alignItems: 'center' } as BoxProps,
  shadowStyle: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'BRAND_COLOR_GRAY_3',
    zIndex: 5,
    backgroundColor: 'WHITE',
  } as BoxProps,
}

interface TitleSubtitleLayoutProps {
  placeHolder?: string
  title?: string
  formatedVal?: string
}

const TitleSubTitleLayout: FC<TitleSubtitleLayoutProps> = ({
  placeHolder,
  title = '',
  formatedVal,
}: TitleSubtitleLayoutProps) => {
  return (
    <Box {...styles.container}>
      <Text type={'h4'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'}>
        {placeHolder}
      </Text>
      <Box margin={0} padding={0} {...styles.subTitleContainer}>
        <Text type={'h4'} color={'BLACK'} fontSize={24} fontFamily={'jiotype-bold'} opacity={title ? 1 : 0.3}>
          {formatedVal || '_^_'}
        </Text>
        <Spacer direction="horizontal" size={8} />

        {formatedVal && shouldShowTooltip(Number(title)) && (
          <TooltipView
            value={getCommaFormatedVal(Number(title.replace('₹', '')), !formatedVal.includes('₹'))}
            alignLeft={true}
          />
        )}
      </Box>
    </Box>
  )
}

export { TitleSubTitleLayout }
